import Divolte from 'services/AirBaltic/Divolte'
import UUID_Utils from 'utils/UUID_Utils'
import conf from 'conf'

class Subscribe {
  static push (name, data) {
    if (conf.divolte) {
      Divolte.doDataPush(name, data)
    }
  }

  static subscribe (state) { // form submit success
    const identity = {
      userUUID: UUID_Utils.create_UUID(),
      email: state.email,
      language: state.language
    }

    this.push('subscribeNewsletter', {
      identity,
    })
  }

  static newsletter (state) { // form submit success
    const identity = {
      userUUID: UUID_Utils.create_UUID(),
      email: state.email,
      language: state.preferredLanguage.toUpperCase(),
      country: state.countryOfResidence.toUpperCase()
    }

    this.push('subscribeNewsletter', {
      identity,
    })
  }
}

export default Subscribe
